import React from 'react'
import ReactDOM from 'react-dom'

export default function AutofillWrapper(DecoratedComponent) {
  return class AutofillComponent extends React.Component {
    constructor(props, context) {
      super(props, context)
      this.inputListeners = []
    }

    componentDidMount() {
      if (this.componentRef && this.componentRef.props && this.componentRef.props.form) {
        if (!navigator.userAgent.match('CriOS')) {
          //this bug is only noticed in ios chrome. skip for everyone else
          return
        }
        const formProp = this.componentRef.props.form
        const inputs = ReactDOM.findDOMNode(this).querySelectorAll('input')
        for (let i = 0; i < inputs.length; i++) {
          const handleInputChange = e => {
            const target = e.target
            formProp.setFieldsValue({
              [target.id]: target.value
            })
          }

          this.inputListeners.push({
            input: inputs[i],
            listener: handleInputChange
          })

          inputs[i].addEventListener('change', handleInputChange)
          inputs[i].addEventListener('blur', handleInputChange)
        }
      }
    }

    componentWillUnmount() {
      let pair
      while ((pair = this.inputListeners.pop())) {
        pair.input.removeEventListener('change', pair.listener)
        pair.input.removeEventListener('blur', pair.listener)
      }
    }

    render() {
      return <DecoratedComponent {...this.props} ref={c => (this.componentRef = c)} />
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/AutoFillWrapper.js